import React, { useState } from "react";
import "./TenantDetails.css";
import Modal from "components/common/Modal/Modal";
import { TenantService } from "services/tenant";
import { formatDate } from "ultils/date-formatter";
import AddEditTenantForm from "components/features/Add-Edit-Tenant-Form/Add-Edit-Tenant-Form";

interface TenantDetailsProps {
  propertyDetails: any;
  tenantList: any; // Passed prop containing property details
  onTenantUpdate: (updatedDetails: any) => void; // Callback for parent to handle updates
}

const TenantDetails: React.FC<TenantDetailsProps> = ({
  tenantList,
  onTenantUpdate,
  propertyDetails,
}) => {
  const [updatedTenantDetails, setTenantDetails] = useState<any>({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [title, setTitle] = useState("Add Tenant");
  const [isEditMode, setIsEditMode] = useState(false);

  const openModal = (type: string, selectedTenant: any) => {
    if (type === "new") {
      setTitle("Add Tenant");
      setIsEditMode(false);
    } else {
      setTitle("Edit Tenant");
      setIsEditMode(true);
      setTenantDetails(selectedTenant);
    }
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setTenantDetails({});
    setIsModalOpen(false);
  };

  const handleSubmit = async (tenantDetailsForm: any, e: React.FormEvent) => {
    e.preventDefault();

    try {
      tenantDetailsForm.propertyId = propertyDetails.propertyId;

      if (!isEditMode) {
        await TenantService.postTenant(tenantDetailsForm);
      } else {
        await TenantService.updateTenant(tenantDetailsForm);
      }

      alert("Tenant details updated successfully");
      onTenantUpdate(tenantDetailsForm); // Notify the parent component of the updated details
    } catch (err) {
      console.error("Failed to update tenant:", err);
      alert("Failed to update tenant details, please refresh and try again.");
    }
  };

  return (
    <div className="">
      <div className={"add-property-container"}>
        <div className="header-container">
          {" "}
          <h1>Tenants</h1>{" "}
          <button className="btn" onClick={() => openModal("new", {})}>
            Add Tenant
          </button>
        </div>

        <div>
          <table style={{ border: 1, width: "100%", textAlign: "left" }}>
            <thead>
              <tr>
                <th>Active</th>
                <th>Full Name</th>
                <th>Notes</th>
                <th>Lease Start Date</th>
                <th>Lease End Date</th>
                <th>Date Added</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {tenantList.length > 0 ? (
                tenantList.map((tenant: any) => (
                  <tr key={tenant.id}>
                    <td>{tenant.active ? "🟢" : "🔴"}</td>
                    <td>{`${tenant.firstName} ${tenant.lastName}`}</td>
                    <td>{tenant.notes}</td>
                    <td>{formatDate(tenant.leaseStartDate, "MM/dd/yyyy")}</td>
                    <td>{formatDate(tenant.leaseEndDate, "MM/dd/yyyy")}</td>
                    <td>
                      {formatDate(tenant.dateAdded, "MM/dd/yyyy HH:mm a")}
                    </td>
                    <td>
                      <button
                        className="btn"
                        onClick={() => openModal("edit", tenant)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6}>No tenants available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <Modal title={title} isOpen={isModalOpen} onClose={closeModal}>
          <AddEditTenantForm
            propertyDetails={propertyDetails}
            onTenantUpdate={handleSubmit}
            unitDetails={{}}
            tenantDetails={updatedTenantDetails}
          />
        </Modal>
      </div>
    </div>
  );
};

export default TenantDetails;
